import { Loader } from 'pixi.js'
import { sceneList } from './config'
// import { $fetchPag } from '@/api'
import { PAGInit } from 'libpag'
import store from '@/store'
import { preloadImgs } from './helper'
export const loadImgPoint = [1, 6, 10, 15, 20, 25]
export const baseUrl =
  '//activity.hdslb.com/blackboard/static/d1cf92bc9dbcd4aba66a240199ecc790/'

// export const list = ['4KYgiuse2h.json', '8YxveC82Hx.json', 'EqGeaCexf9.json']
export const list = [
  'N68Zyr4gOK.json',
  'YimnEbGunf.json',
  'oOtqU37kbN.json',
  'vDFgXC0kJp.json',
  'JlvfXJpRcH.json',
]
// export const list = [
//   '8WcHnO7ZDu.json',
//   'NHkoBmV17l.json',
//   'DGRNOJygv8.json',
//   'JX84Xlkwxb.json',
//   'KgYMWQ0piV.json',
//   'NXUqftmiBM.json',
// ]

export function loadScFn(
  cb: () => void,
  progressCb: (p: number) => void,
  failCb: () => void
) {
  const loadedArr = [0, 0, 0]
  //pixi loader
  const loader = Loader.shared
  loader.baseUrl = baseUrl
  if (Object.keys(loader.resources).length) {
    raceFn(0)
  } else {
    list.forEach((i) => {
      loader.add(i, i)
    })
    loader.load()
    loader.onComplete.add(() => {
      raceFn(0)
    })
    loader.onProgress.add((p) => {
      progressCb && progressCb(Math.min(p.progress, 90))
    })
    loader.onError.add(() => {
      failCb && failCb()
    })
  }
  function raceFn(index: number) {
    console.log('index==>', index)
    loadedArr[index] = 1
    if (loadedArr.every((i) => i === 1)) {
      cb && cb()
    }
  }
  // pag loader
  // const pagList = highlightList.map((i) => i.pagSrc)
  // console.log('pagList==>', pagList)
  // pagList.forEach((i) => {
  //   $fetchPag(i)
  // })
  // Promise.all(pagList.map((i) => $fetchPag(i)))
  //   .then(() => {
  //     raceFn(1)
  //   })
  //   .catch(() => {
  //     failCb && failCb()
  //   })

  // 初始化pag
  PAGInit({
    locateFile: () =>
      '//s1.hdslb.com/bfs/static/draven/film-history/libpag.wasm',
  })
    .then((PAG) => {
      // 储存实例
      store.commit('setPagIns', PAG)
      raceFn(1)
    })
    .catch(() => {
      failCb && failCb()
    })

  // 加载前两页的img
  const preloadImgArr: string[] = []
  sceneList.map((item, index) => {
    const { bg = '', bgIn = '', pic = '', front = '' } = item || {}
    if (
      index <= 1 ||
      index === 9 ||
      index === 20 ||
      index === 23 ||
      index === 25
    ) {
      console.log('%c bg ------> ', 'color:#0f0;', bg)
      preloadImgArr.push(bg, bgIn, pic, front)
    }
  })
  preloadImgs(preloadImgArr)
    .then(() => {
      raceFn(2)
    })
    .catch(() => {
      failCb && failCb()
    })
}

// 加载站点前后所需图片
export function pagePreloadFn(newVal, around = 2) {
  const preloadImgArr: string[] = []
  const curr = newVal - 1
  const len = sceneList.length
  if (curr < 0) return
  const preInx = curr - around <= 0 ? 0 : curr - around
  const nextInx = curr + around >= len ? len : curr + around
  sceneList.map((item, index) => {
    const { bg = '', bgIn = '', pic = '', front = '' } = item || {}
    if (index >= preInx && index <= nextInx) {
      preloadImgArr.push(bg, bgIn, pic, front)
    }
  })
  preloadImgs(preloadImgArr)
}
